import { render } from "./cc-mastercard-icon.svg?vue&type=template&id=63c19f9a"
import script from "./cc-mastercard-icon.svg?vue&type=script&lang=js"
export * from "./cc-mastercard-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4040/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__